/**
 * Created by Dell on 05-02-2020.
 */
import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Redirect} from 'react-router-dom';

class Page401 extends Component {

    render() {
        return (
            <div className="wrapper wrapper-content" style={{padding: "10px 0px 10px 0px"}}>
                {
                    (0 === this.props.jwtToken.length && window.location.href.indexOf("resetPassword") <=0 ) ? (<Redirect to='/login'/>) : null
                }
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Unauthorized URL</h5>
                            </div>
                            <div className="ibox-content table-responsive" style={{minHeight:"360px"}}>
                                <div className="middle-box text-center animated fadeInDown" style={{marginTop:'20px'}}>
                                    <h3>401</h3>
                                    <h3 className="font-bold">Unauthorized URL</h3>

                                    <div className="error-desc">
                                        Sorry, You cannot access this page. <br/>
                                        <br/>
                                        <Link to={'/'} className="btn-sm btn-primary"  style={{color: 'white', fontSize:"13px"}} >
                                            Go to Dashboard</Link>&nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Page401;


// WEBPACK FOOTER //
// ./src/components/errorsPage/401.js